function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M64,12.158a26.244,26.244,0,0,1-7.539,2.067,13.176,13.176,0,0,0,5.771-7.258,26.483,26.483,0,0,1-8.342,3.187,13.139,13.139,0,0,0-22.372,11.97A37.274,37.274,0,0,1,4.459,8.406,13.144,13.144,0,0,0,8.522,25.931a13.133,13.133,0,0,1-5.947-1.648v.164a13.143,13.143,0,0,0,10.53,12.874,13.288,13.288,0,0,1-3.459.46,12.588,12.588,0,0,1-2.471-.244,13.134,13.134,0,0,0,12.261,9.118,26.337,26.337,0,0,1-16.3,5.611A27.9,27.9,0,0,1,0,52.086a37.107,37.107,0,0,0,20.124,5.907c24.152,0,37.353-20,37.353-37.353l-.044-1.7A26.207,26.207,0,0,0,64,12.158Z"
});

function SvgSocialTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.6a331f27.svg";
export { ForwardRef as ReactComponent };